module.exports = __webpack_public_path__ + "img/oio.f74b6e67.svg";